<template>
  <div v-if="parking && program && !loading">
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">Edition du parking {{parking.ref}}</span>
    </sticky>
    <div class="columns is-gapless is-margin-left-on-btn-actions is-padding-top">
      <div class="column is-10 is-9-widescreen is-8-fullhd">
        <div class="has-bg-white is-border">
          <parking-form @submit="submit"
                    :source="parking"
                    :program="program"
                    :loading="saving"
                    :edit="true"
          ></parking-form>
        </div>
      </div>
    </div>
  </div>
  <spinner-round v-else :isLoading="loading"></spinner-round>

</template>

<script>
  import ParkingForm from '@/components/parking/ParkingForm'

  export default {
    name: 'LotCreate',
    data () {
      return {
        loading: true,
        program: null,
        parking: null,
        saving: false
      }
    },
    components: {
      ParkingForm
    },
    methods: {
      getParking (id) {
        this.loading = true
        this.$api.lotService.getOne(id).then(res => {
          this.parking = res.data
          this.getProgram(res.data.program)
        }).catch(() => {
          this.loading = false
        })
      },
      submit (parking) {
        this.saving = true
        this.$api.lotService.put(parking.pk, parking).then(res => {
          this.saving = false
          this.$notify({
            type: 'is-success',
            text: 'Le parking a bien été mise à jour.'
          })
          this.$router.goBack(this.$route)
        }).catch(() => {
          this.saving = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la mise à jour du parking.'
          })
        })
      },
      getProgram (programPk) {
        this.$api.programService.getOne(programPk).then(r => {
          this.program = r.data
          this.loading = false
        })
      }
    },
    created () {
      this.getParking(this.$route.params.id)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/parking/ParkingEdit.vue